import FormSelect from "../../../../../../packages/design-system/src/FormSelect";
import { CustomFormSelect } from "../../../../../../packages/design-system/src/FormSelect/readme-helpers";
import Spacings from "../../../../../../packages/design-system/src/Spacings";
import * as React from 'react';
export default {
  FormSelect,
  CustomFormSelect,
  Spacings,
  React
};